import type { TrapConfig, TrapKind } from "./types";

/** Master feature gate — set to true to enable the "VERSUS" button on title. */
export const VERSUS_ENABLED = true;

// ── Trap tuning ─────────────────────────────────────────────────────────────

export const TRAP_CONFIGS: Record<TrapKind, TrapConfig> = {
  LOCKDOWN_CHAINS: { kind: "LOCKDOWN_CHAINS", cost: 250, cooldownSec: 2 },
  FOG_OVERLAY: { kind: "FOG_OVERLAY", cost: 250, cooldownSec: 2, durationSec: 8 },
  COIN_TAX: { kind: "COIN_TAX", cost: 200, cooldownSec: 2 },
  GROOVE_DRAIN: { kind: "GROOVE_DRAIN", cost: 200, cooldownSec: 2 },
  DOOM_SURGE: { kind: "DOOM_SURGE", cost: 1500, cooldownSec: 2 }
};

export const TRAP_GLOBAL_COOLDOWN_SEC = 2;
export const COIN_TAX_BURN_AMOUNT = 400;
export const DOOM_SURGE_DRAIN_SEC = 5;
export const LOCKDOWN_TILE_COUNT = 6;

// ── Sync tuning ─────────────────────────────────────────────────────────────

export const VERSUS_SYNC_V2_ENABLED = true;
export const HEARTBEAT_INTERVAL_SEC = 1;
export const HEARTBEAT_FULL_POWERUP_EVERY = 5;
export const DISCONNECT_DETECT_SEC = 8;
export const DISCONNECT_FORFEIT_SEC = 30;
export const SNAPSHOT_REQUEST_COOLDOWN_SEC = 1.2;
export const REMOTE_GAMEPLAY_EVENT_BUFFER_MAX = 96;
export const REMOTE_TRAP_EVENT_BUFFER_MAX = 64;
export const REMOTE_GAMEPLAY_GAP_TIMEOUT_SEC = 0.9;
export const DEFERRED_SNAPSHOT_MAX_WAIT_SEC = 0.8;
export const SNAPSHOT_INTERVAL_HEALTHY_SEC = 4.0;
export const SNAPSHOT_INTERVAL_DEGRADED_SEC = 1.5;
export const RECENT_TRAP_SNAPSHOT_MAX = 32;
export const SYNC_SEND_FAILURE_DEGRADED_THRESHOLD = 3;
export const SYNC_RESYNC_DEGRADED_THRESHOLD = 2;
export const SYNC_STABLE_WINDOW_SEC = 5;

// ── Debug ────────────────────────────────────────────────────────────────────

/** Set true for testing: 600s doom clock so you don't die during dev. */
export const VERSUS_DEBUG_LONG_DOOM = false;

// ── Match flow ──────────────────────────────────────────────────────────────

export const MATCH_COUNTDOWN_SEC = 3;

// ── Versus canvas layout ────────────────────────────────────────────────────

export const VERSUS_CANVAS_WIDTH = 780;
export const VERSUS_CANVAS_HEIGHT = 600;
export const VERSUS_PANEL_WIDTH = 360;
export const VERSUS_DIVIDER_WIDTH = 60;
export const VERSUS_DIVIDER_X = 360;
export const VERSUS_OPPONENT_X = 420;

export const VERSUS_MOBILE_CANVAS_WIDTH = 360;

